import { Moment } from "moment-timezone";
/** @format */

import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { of, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { CommuteService } from "../../../services/commute.service";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { ConfigurationService } from "../../../services/configuration.service";
import { ToastService } from "mis-crystal-design-system/toast";
import { HomeDataService } from "../../../services/home-data.service";
import * as moment from "moment";

export interface ICommuteChoice {
  id: number;
  name: string;
  icon: string;
  activeIcon: string;
  disable?: boolean;
}
@Component({
  selector: "[mis-employee-web-exp-commute]",
  templateUrl: "./commute.component.html",
  styleUrls: ["./commute.component.scss"]
})
export class CommuteComponent implements OnInit, OnDestroy {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  private endObs = new Subject<void>();
  reachingOptions: NsEmpWebExpData.ICommuteOption[] = [];
  leavingOptions: NsEmpWebExpData.ICommuteOption[] = [];
  reachingSelection: NsEmpWebExpData.ICommuteOption;
  leavingSelection: NsEmpWebExpData.ICommuteOption;
  @Input() config: NsWISConfigurations.IConfigurations;
  commuteChoices: ICommuteChoice[] = [];
  employeeInfo = this.homeDataSvc.employeeInfo;
  disableParking = false;
  transportActiveIcon: any;
  transportIcon: any;
  parkingScheduleCutoff: number;
  bulkBookingParkingCutoff: boolean = false;
  maxDate: any;
  formattedMaxDate: any;
  constructor(
    public commuteSvc: CommuteService,
    private configSvc: ConfigurationService,
    private toast: ToastService,
    public homeDataSvc: HomeDataService
  ) {}

  ngOnInit(): void {
    this.commuteSvc.commuteDate.pipe(takeUntil(this.endObs)).subscribe(res => {
      // let endDate: any = new Date(res?.endTime);
      let startDate: any = new Date(res?.startTime); // TO DO - CHANGE new Date to Moment
      let currDate: any = moment().startOf("day");

      let diff = Math.abs(currDate - startDate);
      let diffinDays = moment.duration(diff).asDays();

      this.parkingScheduleCutoff = this.config.flattenedSettings.parkingScheduleCutoff;
      // 1. SINGLE DAY BOOKING
      if (this.parkingScheduleCutoff >= 0) {
        diffinDays > this.parkingScheduleCutoff ? (this.disableParking = true) : (this.disableParking = false);
        if (this.disableParking) this.setChoice(this.commuteChoices.find(c => c.id === 0));
      }
      // if(diffinDays > parseInt(this.transportScheduleCutoff)) this.disableTransport = true;
      //2. BULK BOOKING
      // if (currDate - startDate === 0) {
      //    diff= Math.abs(endDate-startDate);
      //    diffinDays = moment.duration(diff).asDays();
      //    diffinDays > parseInt(this.transportScheduleCutoff) ? this.bulkBookingTransportCutoff = true : this.bulkBookingTransportCutoff = false;
      //    this.maxDate = new Date(startDate.setDate(startDate.getDate() + parseInt(this.transportScheduleCutoff)))
      //    this.formattedMaxDate = this.maxDate.split(' ').slice(1).join(' ')
      // }
    });

    this.commuteSvc.formData.pipe(takeUntil(this.endObs)).subscribe(res => {
      const commute = res?.[2];
      [this.reachingOptions, this.leavingOptions] = res;
      this.reachingSelection =
        commute?.login ||
        (this.config.flattenedSettings.enableTransportByDefault && this.reachingOptions.find(item => !item.disable && item.id === "transport"));
      this.leavingSelection =
        commute?.logout ||
        (this.config.flattenedSettings.enableTransportByDefault && this.leavingOptions.find(item => !item.disable && item.id === "transport"));
      this.reachingSelection = this.reachingOptions.find(
        opt => !opt.disable && opt.id === this.reachingSelection?.id && opt.name === this.reachingSelection?.name
      );
      this.leavingSelection = this.leavingOptions.find(
        opt => !opt.disable && opt.id === this.leavingSelection?.id && opt.name === this.leavingSelection?.name
      );
      if (commute?.login?.id === "parking" || commute?.login?.id === "parkingWaitlist") {
        this.setChoice(this.commuteChoices.find(c => c.id === 1));
      }
      this.commuteSvc.setCommute([this.reachingSelection, this.leavingSelection]);
    });

    this.transportIcon = this.config.flattenedSettings.isShuttleRequired ? this.Assets.ICONS.SHUTTLE_DEACTIVE : this.Assets.ICONS.TRANSPORT;
    this.transportActiveIcon = this.config.flattenedSettings.isShuttleRequired
      ? this.Assets.ICONS.SHUTTLE_ACTIVE
      : this.Assets.ICONS.TRANSPORT_ACTIVE;
    this.config.flattenedSettings.showCabs &&
      this.commuteChoices.push({
        id: 0,
        name: "OFFICE CAB",
        icon: this.transportIcon,
        activeIcon: this.transportActiveIcon
        // disable: this.disableTransport
      });
    this.config.flattenedSettings.showParking &&
      this.commuteChoices.push({
        id: 1,
        name: "PARKING",
        icon: this.Assets.ICONS.PARKING,
        activeIcon: this.Assets.ICONS.PARKING_ACTIVE,
        disable: this.commuteSvc.disableParkingSelection
      });
    this.setChoice(this.commuteChoices[0]);
  }

  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }
  checkForNonTransportUser(isTransportUser?: boolean) {
    if (!isTransportUser) {
      this.toast.displayMsg("You are not allowed to make transport request as you are marked as a non transport user.");
    }
  }
  setCommuteSelection(type: 0 | 1, value: NsEmpWebExpData.ICommuteOption): void {
    if (type === 0) {
      this.reachingSelection = value;
      if (value.id !== "transport" && this.leavingSelection?.id === "transport") {
        this.leavingSelection = this.leavingOptions[this.leavingOptions.length - 1];
      }
    } else {
      this.leavingSelection = value;
    }
    if (this.configSvc.isMobile) {
      this.commuteSvc.temporaryCommuteSelection = [this.reachingSelection, this.leavingSelection];
      return;
    }
    this.commuteSvc.setCommute([this.reachingSelection, this.leavingSelection]);
  }

  setChoice(opt: ICommuteChoice): void {
    this.commuteSvc.currentChoice = opt;
  }
}
